class NavLookupController extends AbstractIntegrationController
	@register()
	@inject 'configuration'

	integrationId: 'nav_lookup'

	save: ->
		super(@configuration)
			.then (response) =>
				@configuration = response.data

	afterDisconnect: ->
		@configuration = {}
